import { useState } from 'react';
import { submitReaddyForm, type FormResult } from '@/lib/form';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/dalqv0b8bfvm9eaivsm0';

export default function SubscribeForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'done'>('idle');
  const [result, setResult] = useState<FormResult | null>(null);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    setStatus('loading');
    const res = await submitReaddyForm(form, SUBMIT_ADDR, '订阅成功！新内容上线会第一时间提醒你。');
    setResult(res);
    setStatus('done');
    if (res.ok) form.reset();
  };

  return (
    <div>
      <form
        id="newsletter-subscribe"
        data-readdy-form
        action={SUBMIT_ADDR}
        method="post"
        onSubmit={onSubmit}
        className="flex flex-col sm:flex-row gap-3 max-w-lg"
      >
        <label htmlFor="newsletter-email" className="alt-field">
          邮箱地址
        </label>
        <input
          id="newsletter-email"
          type="email"
          name="email"
          required
          placeholder="填入邮箱，不错过每个热话题"
          className="flex-1 h-12 px-4 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
        />
        <input
          className="alt-field"
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {status === 'loading' ? '提交中…' : '免费订阅'}
        </button>
      </form>
      {status === 'done' && result && (
        <p
          role="status"
          className={`mt-3 text-sm ${result.ok ? 'text-accent-700' : 'text-primary-700'}`}
        >
          {result.message}
        </p>
      )}
    </div>
  );
}